import { render, staticRenderFns } from "./SalaryHistory.vue?vue&type=template&id=1cc83d64&scoped=true"
import script from "./SalaryHistory.vue?vue&type=script&lang=js"
export * from "./SalaryHistory.vue?vue&type=script&lang=js"
import style0 from "./SalaryHistory.vue?vue&type=style&index=0&id=1cc83d64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc83d64",
  null
  
)

export default component.exports